import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-souscriptor-dashboard',
  templateUrl: './souscriptor-dashboard.component.html',
  styleUrls: ['./souscriptor-dashboard.component.css']
})
export class SouscriptorDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
